import { Routes, RouterModule } from "@angular/router";
import { ProjectsListComponent } from "./projects-list.component";
import { ProjectDetailsModule } from "../project-details/project-details.module";

const routes: Routes = [
    { path: '', component: ProjectsListComponent },
    { path: 'project', loadChildren: () => ProjectDetailsModule },
    { path: 'order', loadChildren: () => ProjectDetailsModule },
    { path: 'service', loadChildren: () => ProjectDetailsModule },
    { path: 'consultation', loadChildren: () => ProjectDetailsModule }
  ];

  export const ProjectsListRouting = RouterModule.forChild(routes);
